import CloseIcon from "@mui/icons-material/Close";
import { NavLink } from "react-router-dom";
import * as React from "react";
import Drawer from "@mui/material/Drawer";
import { NAV_LINKS } from "../../../constants/global";
import Login from "../../Login";
import "../../../css/pages/headerMain.scss";

interface Props {
  toggleDrawer: (open: boolean) => void;
  open: boolean;
  loginState: boolean;
  handleLogin: (state: boolean) => void;
}
export default function MobileDrawer({
  toggleDrawer,
  open,
  loginState,
  handleLogin,
}: Props) {
  return (
    <Drawer open={open} onClose={() => toggleDrawer(false)} dir="rtl">
      <nav style={{ minWidth: 300 }} id="mobileNav">
        <ul className="primaryNav">
          <div
            id="mobile-exit"
            className="closeButton"
            onClick={() => toggleDrawer(false)}
          >
            <CloseIcon style={{ color: "white", fontSize: "50px" }} />
          </div>
          {NAV_LINKS.map(({ to, label }) => (
            <li key={to}>
              <NavLink
                key={to}
                to={to}
                onClick={() => toggleDrawer(false)}
                className={({ isActive }) =>
                  isActive ? "headerItemsActive" : ""
                }
              >
                {label}
              </NavLink>
            </li>
          ))}
          <li
            onClick={() => handleLogin(true)}
            onMouseEnter={(e) => e.stopPropagation()}
            onMouseLeave={(e) => e.stopPropagation()}
          >
            <span>پنل ادمین</span>
            <Login
              displayLoginState={loginState}
              closeLoginState={handleLogin}
            />
          </li>
        </ul>
      </nav>
    </Drawer>
  );
}
